import { render, staticRenderFns } from "./CounsellingDetails.vue?vue&type=template&id=3d949aca&scoped=true"
import script from "./CounsellingDetails.vue?vue&type=script&lang=js"
export * from "./CounsellingDetails.vue?vue&type=script&lang=js"
import style0 from "./CounsellingDetails.vue?vue&type=style&index=0&id=3d949aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d949aca",
  null
  
)

export default component.exports